import type { UseQueryResult } from "@tanstack/react-query";

import { useOrgScopedQuery } from "../../query/scope";
import { getForgejoStatus, type ForgejoStatusResponse } from "./api";

// Хук «есть ли подключение Forgejo у текущей org». Используется
// `SettingsConnectionsPage` для переключения между формой и
// connected-режимом.
//
// Org-scoped запрос (см. `src/query/scope.ts`): после смены активной
// организации — другой `connected` статус, кэш прежней org не утекает.
export function useForgejoStatus(): UseQueryResult<
  ForgejoStatusResponse,
  Error
> {
  return useOrgScopedQuery<ForgejoStatusResponse>({
    key: ["connections", "forgejo", "status"],
    queryFn: () => getForgejoStatus(),
    retry: false,
  });
}
